import React from "react";

import BookDisplay from "./BookDisplay";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import SortByAlphaIcon from "@material-ui/icons/SortByAlpha";
const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  searchBar: {
    width: "100%",
  },
  grid: {
    verticalAlign: "text-bottom",
  },
  button: {
    heigth: "100%",
    verticalAlign: "center",
  },
}));

const filterLogic = (book, term) => {
  term = term.toLowerCase();
  return (
    book.title.toLowerCase().includes(term) ||
    book.authors.filter((name) => name.toLowerCase().includes(term)).length > 0
  );
};

const sortLogic = (first, second) => first.title.localeCompare(second.title);

const BookGrid = () => {
  const classes = useStyles();
  const [books, setBooks] = React.useState([]);

  React.useEffect(() => {
      console.log(window.books)
    setBooks(window.books)
  }, [])

  const handleSearch = (e) =>
    setBooks(window.books.filter((item) => filterLogic(item, e.target.value)));

  const handleSort = () => {
    setBooks([...books].sort(sortLogic));
  };

  return (
    <>
      <Grid
        container
        direction="row"
        align="center"
        alignItems="stretch"
        className={classes.grid}
      >
        <Grid item xs={1}>
          <IconButton className={classes.button} onClick={handleSort}>
            <SortByAlphaIcon />
          </IconButton>
        </Grid>
        <Grid item xs={8}>
          <TextField
            label="Căutare..."
            id="margin-none"
            onChange={handleSearch}
            className={classes.searchBar}
            helperText="Căutare după titlu, autor, tag"
          />
          <Grid item xs={3} />
        </Grid>
      </Grid>

      {books.map((book, index) => (
        <BookDisplay key={book.title} index={index + 1} {...book} />
      ))}
    </>
  );
};

export default BookGrid;
